import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class VersionFichier {
    static jsonMap = {
        id: { key: 'id', optional: true },
        dateCreation: { key: 'dateCreation', converter: new DateConverter(), optional: true },
        numero: { key: 'numero', optional: true, default: '' },
        idAuteur: { key: 'idAuteur', optional: true }
    };

    public id: number;
    public dateCreation: moment.Moment;
    public numero: string;
    public idAuteur: number;
}
